<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'

/**
 * @description 回到顶部悬浮按钮
 *  - 滚动超过 400px 时淡入显示
 *  - 点击平滑滚动回顶部
 */
const visible = ref(false)

function onScroll() {
  visible.value = window.scrollY > 400
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => {
  onScroll()
  window.addEventListener('scroll', onScroll, { passive: true })
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>

<template>
  <Transition name="to-top">
    <button v-if="visible"
      class="fixed bottom-6 right-6 z-40 grid h-11 w-11 place-items-center rounded-full glass cursor-pointer text-lg text-slate-200 shadow-lg shadow-black/30 backdrop-blur transition hover:border-brand-400 hover:text-white active:scale-90"
      title="回到顶部" aria-label="回到顶部" @click="scrollToTop">
      ↑
    </button>
  </Transition>
</template>

<style scoped>
.to-top-enter-active,
.to-top-leave-active {
  transition: opacity 0.25s, transform 0.25s;
}

.to-top-enter-from,
.to-top-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>